import { defineModule, isFunction } from '../utils/helpers';

/* eslint-disable @typescript-eslint/naming-convention --
   Both names belong to Complianz, which defines these globals itself. Renaming
   them here would simply stop matching what the plugin exposes. */
declare const show_cookie_banner: unknown;
declare const cmplz_set_category_as_body_class: unknown;
/* eslint-enable @typescript-eslint/naming-convention */

export default defineModule(() => {
  try {
    if (isFunction(show_cookie_banner)) {
      show_cookie_banner();
    }
    if (isFunction(cmplz_set_category_as_body_class)) {
      cmplz_set_category_as_body_class();
    }
  } catch {
    // The globals above only exist once Complianz has loaded its own script.
    // With consent handling off they are absent and referencing them throws,
    // which is not an error worth reporting: there is nothing to show.
  }
});
